import React, { FC } from "react";
import useIsMounted from "~/common/useIsMounted";
export default <Props extends Record<string, unknown>,>(Component: FC<Props>) => (props: Props) => {
  const mounted = useIsMounted();
  return mounted && <Component {...props} /> || <></>;
};